import { Children, PropsWithChildren } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

const Container = styled(Flex)``;

const Item = styled(Box)`
	flex-basis: 0;
	flex-grow: 1;
	flex-shrink: 1;

	:last-child:not(:first-child) {
		border-left: 1px solid ${(props) => props.theme.colors.lightBlue};
	}
`;

export default function MultiMetric({ children }: PropsWithChildren<{}>) {
	const filteredChildren = Children.toArray(children).filter((child) => child != null);

	return (
		<Container>
			{Children.map(filteredChildren, (child, index) => (
				<Item>{child}</Item>
			))}
		</Container>
	);
}
